import React, { Component } from "react";
import FormAvtorization from "../Components/Pages/avtorization/FormAuthorization";
import Way from "../Components/Pages/globalComponents/Way";

export default class Avtorization extends Component {
  state = {
    way: ["Mary Furnitura", "Авторизация"],
    title: "Авторизация",
  };
  render() {
    return (
      <div className="Avtorization">
        <Way title={this.state.title} way={this.state.way} />
        <FormAvtorization />
      </div>
    );
  }
}
